import groupAction from './actions/groupAction';
import strategyActions from './actions/strategyActions';
import languageActions from './actions/language.Actions';
import userInfoActions from './actions/userInfoActions';
import chargerActions from './actions/chargerActions';
import { setAppLoading } from './actions/appActions';
import companyActions from './actions/companyActions';
import businessGroupActions from './actions/businessGroupActions';
import locationActions from './actions/locationActions';
import generalActions from './actions/generalAction';


//export const initiateAppData = () => async (dispatch) => {

//    dispatch(await setAppLoading(true))
//    dispatch(await languageActions.setLanguage("HE"))
//    dispatch(await userInfoActions.getUserDetails())

//    dispatch(await chargerActions.getAllChargers())
//    dispatch(await chargerActions.getFavoriteChargers())
//    dispatch(await groupAction.getGroups())
//    dispatch(await setAppLoading(false))

//    dispatch(await strategyActions.getStrategies())
//    dispatch(await userInfoActions.setIsOPU())
//    dispatch(await userInfoActions.getUserPayment())
//    // dispatch(await userInfoActions.getDrivers())
//    // dispatch(await userInfoActions.getTags())
//    dispatch(await companyActions.getCompany())
//    dispatch(await businessGroupActions.getBusinessGroups())



//    //dispatch(await chargerActions.getChargers())
//    //dispatch(await chargerActions.getDriverChargers())
//    //dispatch(await chargerActions.getPublicChargers())

//}

export const initiateAppData = () => async (dispatch) => {
    dispatch(setAppLoading(true));

    // Sequentially dispatch actions that may have dependencies
    await dispatch(languageActions.setLanguage("HE"));
    await dispatch(userInfoActions.getUserDetails());

    // Dispatch independent actions in parallel
    await Promise.all([
        dispatch(chargerActions.getAllChargers()),
        dispatch(chargerActions.getFavoriteChargers()),
        dispatch(groupAction.getGroups()),
        
        dispatch(strategyActions.getStrategies()),
        dispatch(userInfoActions.setIsOPU()),
        dispatch(userInfoActions.getUserPayment()),
        // dispatch(userInfoActions.getDrivers()),
        // dispatch(userInfoActions.getTags()),
        dispatch(companyActions.getCompany()),
        dispatch(businessGroupActions.getBusinessGroups()),
        dispatch(locationActions.getLoactions()),
        dispatch(generalActions.getLandingPageUrl()),

    ]);
    dispatch(setAppLoading(false));
};
